<template>
  <div>
    <div class="logo" style="cursor:pointer">
      <img :src="config.logoUrl" alt="logo" />
      <span>{{config.logoText}}</span>
      <!-- <div class="user-name">{{loginName}}</div> -->
    </div>
  </div>
</template>
<script>
import {getInitConfig} from '@/config/config';
export default {
  data () {
    return {
      loginName: '',
      logoPath: '',
      organName: '',
      config: ''
    }
  },
  created () {
    // let data = JSON.parse(window.localStorage.getItem('userInfo'));
    // this.loginName =data.loginName;
    // this.logoPath = this.$preffix+data.logoPath;
    // this.organName = data.organName;
    this.config = getInitConfig()
    console.log(this.config)
  }
}
</script>
<style scoped>
.logo>img{
  height: auto;
}
.logo{
  line-height: normal;
  white-space: inherit;
}
.logo span{
  color: #666666;
  line-height: normal !important;
}
.user-name {
  /*line-height: 50px;
    text-align: center;
    font-size: 18px;*/
}
</style>



// WEBPACK FOOTER //
// src/layout/components/SideInfo.vue